import { get } from 'api';
import { APP_PRODUCT_TYPE } from 'appConstants';
import { calculateVirtualPackUomQtyPerPackage, productTypeUrlPrefix } from 'utils';
import { cleanObject } from 'utils/object';

import {
  LOAD_PRODUCTS,
  LOAD_SUBGROUPS,
  LOAD_VIRTUAL_PACKS,
  PRODUCTS_LOADED,
  RESET_PRODUCTS,
  RESET_SUBGROUPS,
  RESET_VIRTUAL_PACKS,
  SUBGROUPS_LOADED,
  SUBGROUPS_SYNC_FAILED,
  SYNC_FAILED,
  VIRTUAL_PACKS_LOADED,
  VIRTUAL_PACKS_SYNC_FAILED,
} from './actionTypes';
import type {
  IGetProductsParams,
  IGetSubgroupsParams,
  IGetVirtualPacksParams,
  IProductsActions,
  IVirtualPack,
} from './types';

const withCalculatedVirtualPackQty = (virtualPack: IVirtualPack): IVirtualPack => ({
  ...virtualPack,
  packageUomQtyPerPackage:
    calculateVirtualPackUomQtyPerPackage(virtualPack.packProducts) ||
    virtualPack.packageUomQtyPerPackage,
});

export const initialActionsState: IProductsActions = {
  loadProducts: () => {},
  loadSubgroups: () => {},
  loadVirtualPacks: () => {},
  resetVirtualPacks: () => {},
  resetProducts: () => {},
  resetSubgroups: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  loadProducts: async (
    params: IGetProductsParams = {},
    productType = APP_PRODUCT_TYPE.FERTILISER,
  ) => {
    dispatch({
      type: LOAD_PRODUCTS,
    });
    const { data, error } = await get(productTypeUrlPrefix(productType, '/products'), {
      params: cleanObject(params),
    });
    if (data && !error) {
      dispatch({
        type: PRODUCTS_LOADED,
        payload: { data, productType, params },
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadSubgroups: async (params: IGetSubgroupsParams = {}) => {
    dispatch({
      type: LOAD_SUBGROUPS,
    });

    const { data, error } = await get('/product-subgroups', { params: cleanObject(params) });

    if (data && !error) {
      dispatch({
        type: SUBGROUPS_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SUBGROUPS_SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadVirtualPacks: async (params: IGetVirtualPacksParams = {}) => {
    dispatch({
      type: LOAD_VIRTUAL_PACKS,
    });

    const { data, error } = await get('/cp/virtual-packs', { params: cleanObject(params) });

    if (data && !error) {
      const virtualPacks = Array.isArray(data)
        ? data.map((virtualPack) => withCalculatedVirtualPackQty(virtualPack))
        : [];

      dispatch({
        type: VIRTUAL_PACKS_LOADED,
        payload: virtualPacks,
      });
    } else {
      dispatch({
        type: VIRTUAL_PACKS_SYNC_FAILED,
        payload: error,
      });
    }
  },
  resetVirtualPacks: () =>
    dispatch({
      type: RESET_VIRTUAL_PACKS,
    }),
  resetProducts: () =>
    dispatch({
      type: RESET_PRODUCTS,
    }),

  resetSubgroups: () =>
    dispatch({
      type: RESET_SUBGROUPS,
    }),
});
